var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"label":"Member role","items":_vm.allRoles},on:{"change":_vm.publish},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }